import { render } from "./EditOrder.vue?vue&type=template&id=bd1fc14e&scoped=true"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"

import "./EditOrder.vue?vue&type=style&index=0&id=bd1fc14e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1fc14e"]])

export default __exports__